import { render, staticRenderFns } from "./MailTemplateForm.vue?vue&type=template&id=72ca6533&"
import script from "./MailTemplateForm.vue?vue&type=script&lang=js&"
export * from "./MailTemplateForm.vue?vue&type=script&lang=js&"
import style0 from "./MailTemplateForm.vue?vue&type=style&index=0&id=72ca6533&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports